import { Fragment, useEffect, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { useTranslation } from 'react-i18next'
import { Button } from '../../../../components'

const T = 'receiving_config.save.modal'
export const REASON_MIN = 3
export const REASON_MAX = 1000

export const SaveReasonModal = ({ open, setOpen, onConfirm, isLoading = false, serverError = null }) => {
  const { t } = useTranslation()
  const ref = useRef(null)
  const [reason, setReason] = useState('')
  useEffect(() => {
    if (open) setReason('')
  }, [open])
  const trimmed = reason.trim()
  const isValid = trimmed.length >= REASON_MIN && trimmed.length <= REASON_MAX
  const close = () => {
    if (!isLoading) setOpen(false)
  }
  const submit = e => {
    e.preventDefault()
    if (isValid && !isLoading) onConfirm(trimmed)
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" initialFocus={ref} onClose={close}>
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
              <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900 mb-4">
                {t(`${T}.title`)}
              </Dialog.Title>
              <form onSubmit={submit} className="space-y-3">
                <label className="block text-sm font-medium text-gray-700" htmlFor="save-reason">
                  {t(`${T}.reason`)}
                </label>
                <textarea
                  id="save-reason"
                  ref={ref}
                  rows={3}
                  maxLength={REASON_MAX}
                  className="shadow-sm block w-full sm:text-sm rounded-md border-gray-300"
                  value={reason}
                  onChange={e => setReason(e.target.value)}
                />
                <p className="text-xs text-gray-500">{t(`${T}.reason_help`)}</p>
                {reason.length > 0 && trimmed.length < REASON_MIN && <p className="text-xs text-red-500">{t(`${T}.reason_required`)}</p>}
                {serverError && <div className="font-bold text-red-500 text-sm">{serverError}</div>}
                <div className="flex justify-end gap-2 pt-2">
                  <Button type="secondary" onClick={close} disabled={isLoading} className="px-4">
                    {t(`${T}.cancel`)}
                  </Button>
                  <Button type="primary" buttonType="submit" loading={isLoading} disabled={!isValid} className="px-4">
                    {t(`${T}.confirm`)}
                  </Button>
                </div>
              </form>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
